import React from "react";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import App from "./App";
import AdminThemeSync from "./components/layout/AdminThemeSync";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <AdminThemeSync />
            <GoogleOAuthProvider clientId={"821599332963-ue836188h72odqi4jd5a1f878lj549qt.apps.googleusercontent.com"}>
                <App />
            </GoogleOAuthProvider>
        </BrowserRouter>
    </React.StrictMode>
);